import { BrowserRouter as Router, Route, Routes, Navigate } from 'react-router-dom'; // Alterando para Routes
import PrivateRoute from './components/common/Authenticated/PrivateRoute';

import Home from './pages/Home';
import Agendar from './pages/Agendar';
import RedefinirSenhaCliente from './pages/RedefinirSenha/RedefinirSenhaCliente';
import RedefinirSenhaColaborador from './pages/RedefinirSenha/RedefinirSenhaColaborador';
import VerificarConta from './pages/VerificarConta';
import Login from './pages/Login/login';

// Cliente
import HomeAuthenticated from './pages/Authenticated/Home/homeAuthenticated';
import Agendamento from './pages/Authenticated/Agendamento/Agendamento';
import Consultas from './pages/Authenticated/Consultas/consultas';
import Eventos from './pages/Authenticated/Eventos/eventos';
import MinhaConta from './pages/Authenticated/MinhaConta/minhaConta';
import MeuPerfil from './pages/Authenticated/MinhaConta/MeuPerfil/meuPerfil';
import MetodosDePagamento from './pages/Authenticated/MinhaConta/MetodosDePagamento/metodosDePagamento';
import AdicionarCartao from './pages/Authenticated/MinhaConta/MetodosDePagamento/adicionarCartao';
import AlterarSenha from './pages/Authenticated/MinhaConta/AlterarSenha/alterarSenha';
import TermosDeUso from './pages/Authenticated/MinhaConta/termosDeUso';
import Suporte from './pages/Authenticated/MinhaConta/Suporte/suporte';

// Colaborador
import HomeColaborador from './pages/Authenticated/Colaborador/Home/homeColaborador';
import Agenda from './pages/Authenticated/Colaborador/Agenda/Agenda';
import BloqueioAgenda from './pages/Authenticated/Colaborador/BloqueioAgenda/bloqueioAgenda';
import MinhaContaColaborador from './pages/Authenticated/Colaborador/MinhaConta/minhaContaColaborador';
import AlterarSenhaColaborador from './pages/Authenticated/Colaborador/MinhaConta/AlterarSenha/alterarSenhaColaborador';
import SuporteColaborador from './pages/Authenticated/Colaborador/MinhaConta/Suporte/suporteColaborador';
import TermosDeUsoColaborador from './pages/Authenticated/Colaborador/MinhaConta/termosDeUso';

const Rotas = () => {
    return (
        <>
            <div className="container-fluid h-100">
                <div className='row h-100'>
                    <Router>
                        <Routes>
                            {/*<Route path='/' exact element={<Home />} />*/}
                            <Route path='/' exact element={<Login />} />
                            <Route path='/agendar/:colaboradorId' exact element={<Agendar />} />
                            <Route path="/redefinir-senha/cliente/:token" element={<RedefinirSenhaCliente />} />
                            <Route path="/redefinir-senha/colaborador/:token" element={<RedefinirSenhaColaborador />} />
                            <Route path="/verificar-conta/:token" element={<VerificarConta />} />
                            <Route path="/login" element={<Login />} />


                            <Route path="/area-restrita/" element={<PrivateRoute><HomeAuthenticated /></PrivateRoute>}/>
                            <Route path="/area-restrita/agendamento/:servicoId" element={<PrivateRoute><Agendamento /></PrivateRoute>} />
                            <Route path="/area-restrita/consultas" element={<PrivateRoute><Consultas /> </PrivateRoute>} />
                            <Route path="/area-restrita/eventos" element={<PrivateRoute><Eventos /> </PrivateRoute>} />
                            <Route path="/area-restrita/minha-conta" element={<PrivateRoute><MinhaConta /> </PrivateRoute>} />
                            <Route path="/area-restrita/minha-conta/perfil" element={<PrivateRoute><MeuPerfil /> </PrivateRoute>} />
                            <Route path="/area-restrita/minha-conta/metodos-pagamento" element={<PrivateRoute><MetodosDePagamento /> </PrivateRoute>} />
                            <Route path="/area-restrita/minha-conta/metodos-pagamento/add" element={<PrivateRoute><AdicionarCartao /> </PrivateRoute>} />
                            <Route path="/area-restrita/minha-conta/alterar-senha" element={<PrivateRoute><AlterarSenha /> </PrivateRoute>} />
                            <Route path="/area-restrita/termos" element={<PrivateRoute><TermosDeUso /> </PrivateRoute>} />
                            <Route path="/area-restrita/minha-conta/suporte" element={<PrivateRoute><Suporte /> </PrivateRoute>} />

                            {/* Colaborador */}
                            <Route path="/area-restrita/colaborador" element={<PrivateRoute><HomeColaborador /> </PrivateRoute>} />
                            <Route path="/area-restrita/colaborador/agenda" element={<PrivateRoute><Agenda /> </PrivateRoute>} />
                            <Route path="/area-restrita/colaborador/bloqueio-agenda" element={<PrivateRoute><BloqueioAgenda /> </PrivateRoute>} />
                            <Route path="/area-restrita/colaborador/minha-conta" element={<PrivateRoute><MinhaContaColaborador /> </PrivateRoute>} />
                            <Route path="/area-restrita/colaborador/minha-conta/alterar-senha" element={<PrivateRoute><AlterarSenhaColaborador /> </PrivateRoute>} />
                            <Route path="/area-restrita/colaborador/termos" element={<PrivateRoute><TermosDeUsoColaborador /> </PrivateRoute>} />
                            <Route path="/area-restrita/colaborador/minha-conta/suporte" element={<PrivateRoute><SuporteColaborador /> </PrivateRoute>} />
                    

                            {/* caso a rota solicitada não exista */}
                            <Route path="*" element={<Navigate to="/login" replace />} />
                            
                        </Routes>
                    </Router>
                </div>
            </div>
        </>
    );
};

export default Rotas;
